<template>
  <div v-if="formData" class="app-container">
    <div class="order-info">
      <div class="info-container">
        <div class="info">
          <div class="info-title">
            <i class="title-icon"></i>
            <span class="title-span">确认订单</span>
          </div>
          <van-divider dashed :style="{ margin: '0 0 0 0',color: '#D7D7D7', borderColor: '#D7D7D7'}" ></van-divider>
          <div v-if="formData.stageName" :class="`${formData.stageName.length > 20 ? 'order-item-stage' : 'order-item'}`">
            <span :class="`${formData.stageName.length > 20 ? 'item-left-stage' : 'item-left'}`">课期</span>
            <span :class="`${formData.stageName.length > 20 ? 'item-right-stage' : 'item-right'}`" >{{formData.stageName}}</span>
          </div>
          <div class="order-item">
            <span class="item-left">主讲老师</span>
            <span class="item-right">{{formData.teacherName}}</span>
          </div>
          <div class="order-item">
            <span class="item-left">开课日期</span>
            <span class="item-right">{{formData.firstClassDate}}</span>
          </div>
          <div class="order-item">
            <span class="item-left">上课时间</span>
            <span class="item-right">{{formData.timeRange +' ' + '(' + formData.frequency + ')'}}</span>
          </div>
          <van-divider class="divider" dashed :style="{color: '#D7D7D7', borderColor: '#D7D7D7'}"></van-divider>
          <div class="order-item">
            <span class="item-left">商品金额</span>
            <div class="item-price">
              <span style='font-size: 10px; font-weight: 600;color: #FE6522;line-height: 36px;'>¥</span>
              <span class="original-price">{{formData.totalPrice.toFixed(2)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="couponList" class="info-coupon">
        <div class="coupon">
          <div class="info-title">
            <i class="title-icon-activity"></i>
            <span class="title-span">优惠活动</span>
          </div>
          <van-divider dashed :style="{ margin: '0 0 0 0'}"></van-divider>
          <div class="coupon-list" v-for="item in couponList" :key="item.couponCode">
            <template v-if="couponList">
              <span class="coupon-name">{{item.couponName}}</span>
              <button class="coupon-icon" :style="`background: url(${selectCoupon===item ? checked : unChecked}) 0% 0% / 100% 100% no-repeat;`" @click="selectCoupon = item"/>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="price">
        <span style='font-size: 12px; font-weight: 600;color: #FE6522;line-height: 36px;'>¥</span>
        <span class="last-price">{{ selectCoupon ? (formData.totalPrice - selectCoupon.discountPrice).toFixed(2): formData.totalPrice.toFixed(2)}}</span>
      </div>
      <button :disabled="disabled" @click="createdOrder">提交订单</button>
    </div>
    <van-overlay :show="disabled">
      <van-loading class="loading" type="spinner" color="#1989fa" vertical>加载中...</van-loading>
    </van-overlay>
  </div>
</template>
<script>
import cookie from 'js-cookie'
import loginUri from '@/utils/_loginUri.js'
import { getOrderInfo, createOrder } from '@/api/order'
import unChecked from '@/assets/img/order/unChecked.png'
import checked from '@/assets/img/order/checked.png'
import { APPID, ACTIVITYCODE, CHANNELID, ORDERLIST } from '@/config/masterorder.js'
import sasdk from './sasdkinit'
const parentId = cookie.get('mbparentid')
const studentId = cookie.get('mbstudentid')
export default {
  data () {
    return {
      formData: null,
      couponList: null,
      selectCoupon: '',
      unChecked,
      checked,
      disabled: false
    }
  },
  methods: {
    createdOrder () {
      this.disabled = true
      sasdk.submitorder()
      createOrder({
        studentId: studentId,
        couponCode: this.selectCoupon.couponCode,
        masterId: this.$route.query.masterId,
        secondChannel: this.$route.query.secondChannel,
        stId: this.$route.query.stId,
        stageId: this.$route.query.stageId
      }).then(res => {
        this.disabled = false
        if (res.data) {
          window.location.href = ORDERLIST
        } else {
          this.$router.push({
            name: 'error',
            query: {
              code: res.code,
              studentId: studentId,
              masterId: this.$route.query.masterId,
              secondChannel: this.$route.query.secondChannel,
              stId: this.$route.query.stId,
              stageId: this.$route.query.stageId,
              errorMessage: res.message
            }
          })
        }
      })
    }
  },
  created () {
    if (parentId) {
      getOrderInfo({ studentId: studentId, stageId: this.$route.query.stageId }).then(res => {
        if (res.data) {
          sasdk.viewindex()
          this.formData = res.data
          this.couponList = res.data.coupons
          if (this.couponList) {
            this.couponList.forEach((item) => {
              if (item.optimalFlag) {
                this.selectCoupon = item
              }
            })
          }
        } else {
          this.$router.push({
            name: 'error',
            query: {
              code: res.code,
              studentId: studentId,
              masterId: this.$route.query.masterId,
              secondChannel: this.$route.query.secondChannel,
              stId: this.$route.query.stId,
              stageId: this.$route.query.stageId,
              errorMessage: res.message
            }
          })
        }
      })
    } else {
      cookie.remove('mbparentid')
      window.location.href = loginUri(APPID, CHANNELID, ACTIVITYCODE)
    }
  }
}
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  background: #F2F2F2;
  overflow: hidden;
  position:relative;
  box-sizing: border-box;
  padding-bottom: 128px;
}
.order-info {
  width: 686px;
  margin: 32px auto 0 auto;
}
.info-title {
  line-height: 96px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
}
.title-icon {
  width: 44px;
  height: 44px;
  display: inline-block;
  background: url('~@/assets/img/order/icon_title.png') no-repeat;
  background-size:100% 100%;
  border-radius: 8px;
  vertical-align: middle;
  margin-right: 18px;
}
.title-span {
  font-size: 28px;
  font-weight: 600;
  color: #333333;
}
.footer {
  height: 128px;
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  box-shadow: 0px -2px 14px 0px rgba(0, 0, 0, 0.05);
  button {
    width: 240px;
    height: 80px;
    background: #FE6522;
    border-radius: 16px;
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    margin: auto 30px auto 0px;
  }
}
.info-container {
  background: #FFFFFF;
  height: 516px;
  border-radius: 20px;
  margin-bottom: 32px;
}
.info {
  margin: 0px 32px 32px 32px;
}
.order-item,.order-item-stage {
  height: 72px;
  width: 622px;
  display: flex;
  justify-content: space-between;
}
.order-item-stage {
  height: 80px;
}
.item-left,.item-right,.item-left-stage,.item-right-stage {
  font-size: 28px;
  font-weight: 400;
  color: #333333;
  line-height: 72px;
}
.item-left-stage,.item-right-stage {
  line-height: 45px;
}
.item-right-stage {
  width: 450px;
}
.item-right {
  text-align:right
}
.item-price {
  height: 72px;
  font-size: 28px;
  font-weight: 600;
  color: #FE6522;
  line-height: 72px;
}
.last-price {
  height: 128px;
  font-size: 70px;
  font-weight: 600;
  color: #FE6522;
  line-height: 128px;
}
.original-price{
  height: 72px;
  font-size: 38px;
  font-weight: 600;
  color: #FE6522;
  line-height: 72px;
}
.info-coupon {
  width: 686px;
  background: #FFFFFF;
  border-radius: 20px;
}
.coupon {
  margin: 0px 32px 32px 32px;
}
.title-icon-activity {
  width: 44px;
  height: 44px;
  display: inline-block;
  background: url('~@/assets/img/order/icon_cupton.png') no-repeat;
  background-size:100% 100%;
  border-radius: 8px;
  vertical-align: middle;
  margin-right: 18px;
}
.coupon-list {
  line-height: 96px;
  display: flex;
  justify-content: space-between;
}
.coupon-name {
  font-size: 28px;
  font-weight: 400;
  color: #333333;
  display: inline-block;
}
.coupon-icon {
  width: 40px;
  height: 40px;
  margin: auto 0 auto 0;
}
.price {
  margin: auto 0px auto 32px;
}
.divider {
  margin: 16px 0 24px 0;
}
.loading {
  text-align: center;
  margin-top: 400px;
}
</style>
